import React, { useState } from 'react';
import { MapPin, Clock, DollarSign, Star, Camera, Upload, X, Plus, Sparkles, Send, Crown, Zap, Shield, ChevronDown, ChevronRight, AlertCircle, CheckCircle } from 'lucide-react';
import { useDispatch } from 'react-redux';
import { addJob } from '../../../Redux/Slices/Pages/Jobs/JobsSlice';

const CreateJobPost = () => {
    const dispatch =useDispatch();

  const [formData, setFormData] = useState({
    title: '',
    jobDescription: '',
    category: '',
    minPrice: '',
    maxPrice: '',
    timeRange: '',
    location: '',
    priority: 'medium',
    tags: [],
    workImages: [],
    featured: false,
    bonus: ''
  });

  console.log(formData,"formdata")
  const [currentTag, setCurrentTag] = useState('');
  const [showSuccess, setShowSuccess] = useState(false);
  const [dragActive, setDragActive] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState('');


  const categories = [
    'Electrician', 'Plumber', 'AC Technician', 'Cleaner', 
    'Carpenter', 'Mechanic', 'Painter', 'Mason', 'Gardener', 
    'Handyman', 'Interior Designer', 'Contractor'
  ];

  const timeRanges = [
    'ASAP', 'Today', 'Tomorrow', 'This Weekend', 
    'Next 3 Days', 'This Week', 'Next Week', 
    'Flexible This Week', '2-3 Days Work', '2-3 Weeks Project'
  ];

  const priorityOptions = [
    { value: 'urgent', label: 'Urgent', color: 'from-red-500 to-orange-500' },
    { value: 'high', label: 'High Priority', color: 'from-orange-500 to-yellow-500' },
    { value: 'medium', label: 'Medium', color: 'from-blue-500 to-cyan-500' },
    { value: 'low', label: 'Low Priority', color: 'from-green-500 to-teal-500' }
  ];

  const handleInputChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const addTag = () => {
    if (currentTag.trim() && !formData.tags.includes(currentTag.trim())) {
      setFormData(prev => ({
        ...prev,
        tags: [...prev.tags, currentTag.trim()]
      }));
      setCurrentTag('');
    }
  };

  const removeTag = (tagToRemove) => {
    setFormData(prev => ({
      ...prev,
      tags: prev.tags.filter(tag => tag !== tagToRemove)
    }));
  };

  const handleImageUpload = (files) => {
    const newImages = Array.from(files).slice(0, 3 - formData.workImages.length);
    newImages.forEach(file => {
      const reader = new FileReader();
      reader.onload = (e) => {
        setFormData(prev => ({
          ...prev,
          workImages: [...prev.workImages, e.target.result]
        }));
      };
      reader.readAsDataURL(file);
    });
  };

  const removeImage = (index) => {
    setFormData(prev => ({
      ...prev,
      workImages: prev.workImages.filter((_, i) => i !== index)
    }));
  };

  const handleDrag = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === "dragenter" || e.type === "dragover") {
      setDragActive(true);
    } else if (e.type === "dragleave") {
      setDragActive(false);
    }
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
    
    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      handleImageUpload(e.dataTransfer.files);
    }
  };

  const handleSubmit = () => {
    dispatch(addJob(formData))
    setShowSuccess(true);
    setTimeout(() => setShowSuccess(false), 3000);
  };

  const isFormValid = formData.title && formData.jobDescription && formData.category && 
                     formData.minPrice && formData.maxPrice && formData.timeRange && formData.location;

  return (
    <div className=" bg-gradient-to-br from-slate-900 via-blue-700 to-slate-900">
      {/* Animated Background */}
      <div className="fixed inset-0 overflow-hidden">
        <div className="absolute -inset-10 opacity-50">
          <div className="absolute top-1/4 left-1/4 w-72 h-72 bg-purple-500 rounded-full mix-blend-multiply filter blur-xl animate-blob"></div>
          <div className="absolute top-1/3 right-1/4 w-72 h-72 bg-yellow-500 rounded-full mix-blend-multiply filter blur-xl animate-blob animation-delay-2000"></div>
          <div className="absolute bottom-1/4 left-1/3 w-72 h-72 bg-pink-500 rounded-full mix-blend-multiply filter blur-xl animate-blob animation-delay-4000"></div>
        </div>
      </div>

      {/* Header */}
      <div className="relative z-10 bg-black/20 backdrop-blur-xl border-b border-white/10">
        <div className="max-w-4xl mx-auto px-4 py-6">
          <div className="flex items-center space-x-4">
            <div className="w-12 h-12 bg-gradient-to-r from-purple-500 to-pink-500 rounded-2xl flex items-center justify-center shadow-lg">
              <Plus className="w-6 h-6 text-white" />
            </div>
            <div>
              <h1 className="text-3xl font-bold text-white">Create Job Post</h1>
              <p className="text-purple-200">Post your project and get expert proposals</p>
            </div>
          </div>
        </div>
      </div>

      {/* Form Container */}
      <div className="relative z-10 max-w-4xl mx-auto px-4 py-8">
        <div className="space-y-8">
          
          {/* Main Info Card */}
          <div className="bg-gradient-to-r from-purple-600/20 to-pink-600/20 p-[2px] rounded-3xl">
            <div className="bg-gray-900/95 backdrop-blur-xl rounded-3xl p-8">
              <div className="flex items-center space-x-3 mb-6">
                <Sparkles className="w-6 h-6 text-purple-400" />
                <h2 className="text-2xl font-bold text-white">Job Details</h2>
              </div>

              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                {/* Left Column */}
                <div className="space-y-6">
                  {/* Job Title */}
                  <div>
                    <label className="block text-sm font-semibold text-white mb-3">Job Title *</label>
                    <input
                      type="text"
                      value={formData.title}
                      onChange={(e) => handleInputChange('title', e.target.value)}
                      placeholder="e.g., Premium Electrical Wiring & Smart Home Setup"
                      className="w-full px-4 py-4 bg-gray-800 border border-gray-700 rounded-2xl focus:ring-2 focus:ring-purple-500 focus:border-transparent transition-all text-white placeholder-gray-400"
                      required
                    />
                  </div>

                  {/* Category */}
                  <div>
                    <label className="block text-sm font-semibold text-white mb-3">Category *</label>
                    <div className="relative">
                      <select
                        value={formData.category}
                        onChange={(e) => handleInputChange('category', e.target.value)}
                        className="w-full px-4 py-4 bg-gray-800 border border-gray-700 rounded-2xl focus:ring-2 focus:ring-purple-500 focus:border-transparent transition-all text-white appearance-none cursor-pointer"
                        required
                      >
                        <option value="">Select a category</option>
                        {categories.map(cat => (
                          <option key={cat} value={cat}>{cat}</option>
                        ))}
                      </select>
                      <ChevronDown className="absolute right-4 top-4 w-5 h-5 text-gray-400 pointer-events-none" />
                    </div>
                  </div>

                  {/* Budget Range */}
                  <div>
                    <label className="block text-sm font-semibold text-white mb-3">Budget Range *</label>
                    <div className="grid grid-cols-2 gap-4">
                      <div className="relative">
                        <DollarSign className="absolute left-4 top-4 w-5 h-5 text-purple-400" />
                        <input
                          type="number"
                          value={formData.minPrice}
                          onChange={(e) => handleInputChange('minPrice', e.target.value)}
                          placeholder="Min amount"
                          className="w-full pl-12 pr-4 py-4 bg-gray-800 border border-gray-700 rounded-2xl focus:ring-2 focus:ring-purple-500 focus:border-transparent transition-all text-white placeholder-gray-400"
                          required
                        />
                      </div>
                      <div className="relative">
                        <DollarSign className="absolute left-4 top-4 w-5 h-5 text-purple-400" />
                        <input
                          type="number"
                          value={formData.maxPrice}
                          onChange={(e) => handleInputChange('maxPrice', e.target.value)}
                          placeholder="Max amount"
                          className="w-full pl-12 pr-4 py-4 bg-gray-800 border border-gray-700 rounded-2xl focus:ring-2 focus:ring-purple-500 focus:border-transparent transition-all text-white placeholder-gray-400"
                          required
                        />
                      </div>
                    </div>
                  </div>

                  {/* Time Range */}
                  <div>
                    <label className="block text-sm font-semibold text-white mb-3">Timeline *</label>
                    <div className="relative">
                      <select
                        value={formData.timeRange}
                        onChange={(e) => handleInputChange('timeRange', e.target.value)}
                        className="w-full px-4 py-4 bg-gray-800 border border-gray-700 rounded-2xl focus:ring-2 focus:ring-purple-500 focus:border-transparent transition-all text-white appearance-none cursor-pointer"
                        required
                      >
                        <option value="">Select timeline</option>
                        {timeRanges.map(time => (
                          <option key={time} value={time}>{time}</option>
                        ))}
                      </select>
                      <ChevronDown className="absolute right-4 top-4 w-5 h-5 text-gray-400 pointer-events-none" />
                    </div>
                  </div>
                </div>

                {/* Right Column */}
                <div className="space-y-6">
                  {/* Description */}
                  <div>
                    <label className="block text-sm font-semibold text-white mb-3">Job Description *</label>
                    <textarea
                      value={formData.jobDescription}
                      onChange={(e) => handleInputChange('jobDescription', e.target.value)}
                      placeholder="Describe your project in detail. What needs to be done? Any specific requirements?"
                      rows={6}
                      className="w-full px-4 py-4 bg-gray-800 border border-gray-700 rounded-2xl focus:ring-2 focus:ring-purple-500 focus:border-transparent transition-all resize-none text-white placeholder-gray-400"
                      required
                    />
                  </div>

                  {/* Location */}
                  <div>
                    <label className="block text-sm font-semibold text-white mb-3">Location *</label>
                    <div className="relative">
                      <MapPin className="absolute left-4 top-4 w-5 h-5 text-purple-400" />
                      <input
                        type="text"
                        value={formData.location}
                        onChange={(e) => handleInputChange('location', e.target.value)}
                        placeholder="e.g., Kozhikode, Kerala"
                        className="w-full pl-12 pr-4 py-4 bg-gray-800 border border-gray-700 rounded-2xl focus:ring-2 focus:ring-purple-500 focus:border-transparent transition-all text-white placeholder-gray-400"
                        required
                      />
                    </div>
                  </div>

                  {/* Priority */}
                  <div>
                    <label className="block text-sm font-semibold text-white mb-3">Priority Level</label>
                    <div className="grid grid-cols-2 gap-3">
                      {priorityOptions.map(option => (
                        <button
                          key={option.value}
                          type="button"
                          onClick={() => handleInputChange('priority', option.value)}
                          className={`p-3 rounded-2xl border-2 transition-all ${
                            formData.priority === option.value
                              ? `bg-gradient-to-r ${option.color} border-transparent text-white`
                              : 'bg-gray-800 border-gray-700 text-gray-400 hover:border-gray-600'
                          }`}
                        >
                          <div className="text-sm font-semibold">{option.label}</div>
                        </button>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Images Upload Card */}
          <div className="bg-gradient-to-r from-blue-600/20 to-cyan-600/20 p-[2px] rounded-3xl">
            <div className="bg-gray-900/95 backdrop-blur-xl rounded-3xl p-8">
              <div className="flex items-center space-x-3 mb-6">
                <Camera className="w-6 h-6 text-blue-400" />
                <h2 className="text-2xl font-bold text-white">Project Images</h2>
                <span className="text-sm text-gray-400">(Optional - up to 3 images)</span>
              </div>

              {/* Image Upload Area */}
              <div
                className={`relative border-2 border-dashed rounded-3xl p-8 transition-all ${
                  dragActive
                    ? 'border-blue-500 bg-blue-500/10'
                    : 'border-gray-600 hover:border-gray-500'
                }`}
                onDragEnter={handleDrag}
                onDragLeave={handleDrag}
                onDragOver={handleDrag}
                onDrop={handleDrop}
              >
                <input
                  type="file"
                  multiple
                  accept="image/*"
                  onChange={(e) => handleImageUpload(e.target.files)}
                  className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
                />
                <div className="text-center">
                  <Upload className="w-12 h-12 text-gray-400 mx-auto mb-4" />
                  <p className="text-white font-semibold mb-2">Drop images here or click to upload</p>
                  <p className="text-gray-400 text-sm">PNG, JPG up to 10MB each</p>
                </div>
              </div>

              {/* Uploaded Images */}
              {formData.workImages.length > 0 && (
                <div className="grid grid-cols-3 gap-4 mt-6">
                  {formData.workImages.map((image, index) => (
                    <div key={index} className="relative group">
                      <img
                        src={image}
                        alt={`Upload ${index + 1}`}
                        className="w-full h-32 object-cover rounded-2xl"
                      />
                      <button
                        type="button"
                        onClick={() => removeImage(index)}
                        className="absolute -top-2 -right-2 w-6 h-6 bg-red-500 text-white rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity"
                      >
                        <X className="w-4 h-4" />
                      </button>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>

          {/* Additional Options Card */}
          <div className="bg-gradient-to-r from-green-600/20 to-emerald-600/20 p-[2px] rounded-3xl">
            <div className="bg-gray-900/95 backdrop-blur-xl rounded-3xl p-8">
              <div className="flex items-center space-x-3 mb-6">
                <Zap className="w-6 h-6 text-green-400" />
                <h2 className="text-2xl font-bold text-white">Additional Options</h2>
              </div>

              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                {/* Tags */}
                <div>
                  <label className="block text-sm font-semibold text-white mb-3">Job Tags</label>
                  <div className="flex space-x-2 mb-3">
                    <input
                      type="text"
                      value={currentTag}
                      onChange={(e) => setCurrentTag(e.target.value)}
                      placeholder="Add a tag (e.g., Licensed Required)"
                      className="flex-1 px-4 py-3 bg-gray-800 border border-gray-700 rounded-xl focus:ring-2 focus:ring-green-500 focus:border-transparent transition-all text-white placeholder-gray-400"
                      onKeyPress={(e) => e.key === 'Enter' && (e.preventDefault(), addTag())}
                    />
                    <button
                      type="button"
                      onClick={addTag}
                      className="px-4 py-3 bg-green-600 hover:bg-green-500 text-white rounded-xl transition-all"
                    >
                      <Plus className="w-5 h-5" />
                    </button>
                  </div>
                  {formData.tags.length > 0 && (
                    <div className="flex flex-wrap gap-2">
                      {formData.tags.map((tag, index) => (
                        <span
                          key={index}
                          className="px-3 py-1 bg-green-500/20 border border-green-400/30 text-green-300 rounded-lg text-sm font-medium flex items-center space-x-2"
                        >
                          <span>{tag}</span>
                          <button
                            type="button"
                            onClick={() => removeTag(tag)}
                            className="text-green-300 hover:text-white"
                          >
                            <X className="w-3 h-3" />
                          </button>
                        </span>
                      ))}
                    </div>
                  )}
                </div>

                {/* Bonus & Featured */}
                <div className="space-y-6">
                  {/* Bonus Amount */}
                  <div>
                    <label className="block text-sm font-semibold text-white mb-3">Completion Bonus</label>
                    <div className="relative">
                      <Zap className="absolute left-4 top-4 w-5 h-5 text-green-400" />
                      <input
                        type="number"
                        value={formData.bonus}
                        onChange={(e) => handleInputChange('bonus', e.target.value)}
                        placeholder="Optional bonus amount"
                        className="w-full pl-12 pr-4 py-4 bg-gray-800 border border-gray-700 rounded-2xl focus:ring-2 focus:ring-green-500 focus:border-transparent transition-all text-white placeholder-gray-400"
                      />
                    </div>
                    <p className="text-xs text-gray-400 mt-2">Extra incentive for quality work</p>
                  </div>

                  {/* Featured Post */}
                  <div>
                    <label className="flex items-center space-x-3 cursor-pointer">
                      <input
                        type="checkbox"
                        checked={formData.featured}
                        onChange={(e) => handleInputChange('featured', e.target.checked)}
                        className="w-5 h-5 text-yellow-500 bg-gray-800 border-gray-700 rounded focus:ring-yellow-500 focus:ring-2"
                      />
                      <div className="flex items-center space-x-2">
                        <Crown className="w-5 h-5 text-yellow-500" />
                        <span className="text-white font-semibold">Make this a Featured Post</span>
                      </div>
                    </label>
                    <p className="text-xs text-gray-400 mt-2 ml-8">Get 3x more visibility and responses</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Submit Button */}
          <div className="flex justify-center">
            <button
              type="button"
              onClick={handleSubmit}
              disabled={!isFormValid}
              className="bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-500 hover:to-pink-500 disabled:from-gray-600 disabled:to-gray-700 text-white px-12 py-4 rounded-full font-bold text-lg flex items-center space-x-3 shadow-2xl hover:shadow-purple-500/25 transform hover:scale-105 disabled:transform-none disabled:cursor-not-allowed transition-all duration-300"
            >
              <Send className="w-6 h-6" />
              <span>Post Job</span>
              <ChevronRight className="w-6 h-6" />
            </button>
          </div>

          {/* Form Validation Hint */}
          {!isFormValid && (
            <div className="flex items-center justify-center space-x-2 text-amber-400">
              <AlertCircle className="w-5 h-5" />
              <span className="text-sm">Please fill in all required fields to post your job</span>
            </div>
          )}
        </div>
      </div>

      {/* Success Modal */}
      {showSuccess && (
        <div className="fixed inset-0 bg-black/80 backdrop-blur-sm flex items-center justify-center z-50 p-4">
          <div className="bg-gradient-to-r from-green-600 to-emerald-600 p-[2px] rounded-3xl max-w-md w-full">
            <div className="bg-gray-900 rounded-3xl overflow-hidden p-8 text-center">
              <div className="w-16 h-16 bg-green-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <CheckCircle className="w-8 h-8 text-white" />
              </div>
              <h3 className="text-2xl font-bold text-white mb-2">Job Posted Successfully!</h3>
              <p className="text-green-200 mb-6">Your job post is now live and professionals can start sending proposals.</p>
              <button
                onClick={() => setShowSuccess(false)}
                className="bg-green-600 hover:bg-green-500 text-white px-8 py-3 rounded-full font-semibold transition-all"
              >
                Great!
              </button>
            </div>
          </div>
        </div>
      )}

      <style jsx>{`
        @keyframes blob {
          0% {
            transform: translate(0px, 0px) scale(1);
          }
          33% {
            transform: translate(30px, -50px) scale(1.1);
          }
          66% {
            transform: translate(-20px, 20px) scale(0.9);
          }
          100% {
            transform: translate(0px, 0px) scale(1);
          }
        }
        .animate-blob {
          animation: blob 7s infinite;
        }
        .animation-delay-2000 {
          animation-delay: 2s;
        }
        .animation-delay-4000 {
          animation-delay: 4s;
        }
      `}</style>
    </div>
  );
};

export default CreateJobPost;